var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "popular-parlay" }, [
    _vm.betType === "Parlay"
      ? _c("div", { staticClass: "parlays-container parlay" }, [
          _c(
            "div",
            {
              staticClass: "parlay-header",
              on: {
                click: function($event) {
                  return _vm.viewMore(
                    _vm.parlays,
                    "Parlay",
                    "popularparlays",
                    _vm.parlays.IDFWMarketGroup
                  )
                }
              }
            },
            [
              _c("div", { staticClass: "title-wrapper-potential-return" }, [
                _c("p", {
                  staticClass: "header-title",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t(
                        "Popular.Parlays." +
                          (_vm.isTeaser(_vm.parlays.SelectionData)
                            ? "Teaser"
                            : "Leg"),
                        { num: _vm.parlays.SelectionData.length }
                      )
                    )
                  }
                }),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "potential-return" },
                  [
                    _c("odds", {
                      attrs: {
                        potentialReturn: _vm.parlayPotentialReturn(
                          _vm.parlays.BetCalculation.Calculation
                        ),
                        na: "-"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("p", {
                staticClass: "number-of-selections",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("Popular.Parlays.Selections", {
                      num: _vm.parlays.SelectionData.length
                    })
                  )
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "content-wrapper",
              on: {
                click: function($event) {
                  return _vm.viewMore(
                    _vm.parlays,
                    "Parlay",
                    "popularparlays",
                    _vm.parlays.IDFWMarketGroup
                  )
                }
              }
            },
            _vm._l(_vm.parlays.SelectionData, function(parlay, index) {
              return _c(
                "div",
                {
                  key: parlay.selections[0].idfoselection,
                  staticClass: "parlay-selection parlay",
                  class: {
                    "less-then-4-legs": _vm.parlays.SelectionData.length < 4
                  }
                },
                [
                  _c("div", { staticClass: "leg-icon" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _c("div", { staticClass: "content-left" }, [
                      _c(
                        "span",
                        { staticClass: "selection-name" },
                        [
                          _vm._v(_vm._s(parlay.selections[0].name) + " "),
                          _c("handicap", {
                            attrs: { selection: parlay.selections[0] }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "market-name" }, [
                        _vm._v(_vm._s(parlay.market.name))
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "event-name",
                          on: {
                            click: function($event) {
                              return _vm.goToEvent(
                                parlay.market,
                                "popularparlays",
                                _vm.parlays.SelectionData,
                                "Parlay",
                                _vm.parlays.IDFWMarketGroup,
                                undefined
                              )
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.isAmericanSport(parlay.market)))]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "content-right" }, [
                      _c(
                        "span",
                        { staticClass: "potential-return" },
                        [
                          _vm.parlays.BetCalculation.Calculation
                            .PotentialReturns.PerSelection[
                            parlay.selections[0].idfoselection
                          ].PotentialReturn
                            ? _c("odds", {
                                attrs: {
                                  potentialReturn:
                                    _vm.parlays.BetCalculation.Calculation
                                      .PotentialReturns.PerSelection[
                                      parlay.selections[0].idfoselection
                                    ].PotentialReturn,
                                  na: "-"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "start-date" }, [
                        _vm._v(_vm._s(_vm.formatDate(parlay.market.tsstart)))
                      ])
                    ])
                  ])
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.showViewMore && _vm.parlays.SelectionData.length > 3
            ? _c("div", { staticClass: "view-more-container" }, [
                _c("div", { staticClass: "leg-icon" }),
                _vm._v(" "),
                _c("div", { staticClass: "view-more" }, [
                  _c("button", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.parlays.SelectionData.length - 3 > 1
                          ? _vm.$t("Popular.Parlays.ViewMoreThenOne", {
                              num: _vm.parlays.SelectionData.length - 3
                            })
                          : _vm.$t("Popular.Parlays.ViewMore", {
                              num: _vm.parlays.SelectionData.length - 3
                            })
                      )
                    },
                    on: {
                      click: function($event) {
                        return _vm.viewMore(
                          _vm.parlays,
                          "Parlay",
                          "popularparlays",
                          _vm.parlays.IDFWMarketGroup
                        )
                      }
                    }
                  })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "add-to-betslip-wrapper" }, [
            _c(
              "div",
              {
                staticClass: "add-to-betslip-button",
                on: {
                  click: function($event) {
                    return _vm.addToBetslip(
                      _vm.parlays.SelectionData,
                      "popularparlays",
                      "Parlay",
                      _vm.parlays.IDFWMarketGroup
                    )
                  }
                }
              },
              [
                _c("button", [
                  _vm._v(_vm._s(_vm.$t("Popular.Parlays.AddToBetslip")))
                ]),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("Popular.Parlays.Potential.Return", {
                        num:
                          _vm.winning(_vm.parlays.BetCalculation.Calculation) ||
                          "-",
                        stake: _vm.parlayStake
                      })
                    )
                  }
                })
              ]
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.betType === "SGP"
      ? _c(
          "div",
          {
            key: "sgp-event-" + _vm.parlays.SelectionData[0].market.idfoevent,
            staticClass: "parlays-container SGP"
          },
          [
            _c(
              "div",
              {
                staticClass: "parlay-header",
                on: {
                  click: function($event) {
                    return _vm.viewMore(
                      _vm.parlays,
                      "SGP",
                      "popularparlays",
                      _vm.parlays.IDFWMarketGroup
                    )
                  }
                }
              },
              [
                _c("div", { staticClass: "title-wrapper" }, [
                  _c("div", { staticClass: "sgp-title-wrapper" }, [
                    _c("span", { staticClass: "sgp-icon" }),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "header-title",
                        on: {
                          click: function($event) {
                            return _vm.goToEvent(
                              _vm.parlays.SelectionData[0].market,
                              "popularparlays",
                              _vm.parlays.SelectionData,
                              "SGP",
                              _vm.parlays.IDFWMarketGroup,
                              undefined
                            )
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.isAmericanSport(
                              _vm.parlays.SelectionData[0].market
                            )
                          )
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "title-wrapper-potential-return" }, [
                    _c(
                      "span",
                      { staticClass: "potential-return" },
                      [
                        _c("odds", {
                          attrs: {
                            potentialReturn: _vm.parlayPotentialReturn(
                              _vm.parlays.BetCalculation.ProviderCalculation,
                              "SGP"
                            ),
                            na: "-"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("p", {
                  staticClass: "number-of-selections",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("Popular.Parlays.Selections", {
                        num: _vm.parlays.SelectionData.length
                      })
                    )
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "content-wrapper",
                on: {
                  click: function($event) {
                    return _vm.viewMore(
                      _vm.parlays,
                      "SGP",
                      "popularparlays",
                      _vm.parlays.IDFWMarketGroup
                    )
                  }
                }
              },
              _vm._l(_vm.parlays.SelectionData, function(parlay, index) {
                return _c(
                  "div",
                  {
                    key: parlay.selections[0].idfoselection,
                    staticClass: "parlay-selection SGP"
                  },
                  [
                    _c("div", { staticClass: "leg-icon" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "content-left" }, [
                      _c(
                        "span",
                        { staticClass: "selection-name" },
                        [
                          _vm._v(_vm._s(parlay.selections[0].name) + " "),
                          _c("handicap", {
                            attrs: { selection: parlay.selections[0] }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "market-name" }, [
                        _vm._v(_vm._s(parlay.market.name))
                      ])
                    ])
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm.showViewMore && _vm.parlays.SelectionData.length > 4
              ? _c("div", { staticClass: "view-more-container" }, [
                  _c("div", { staticClass: "leg-icon" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "view-more" }, [
                    _c("button", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.parlays.SelectionData.length - 4 > 1
                            ? _vm.$t("Popular.Parlays.ViewMoreThenOne", {
                                num: _vm.parlays.SelectionData.length - 4
                              })
                            : _vm.$t("Popular.Parlays.ViewMore", {
                                num: _vm.parlays.SelectionData.length - 4
                              })
                        )
                      },
                      on: {
                        click: function($event) {
                          return _vm.viewMore(
                            _vm.parlays,
                            "SGP",
                            "popularparlays",
                            _vm.parlays.IDFWMarketGroup
                          )
                        }
                      }
                    })
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "add-to-betslip-wrapper" }, [
              _c(
                "div",
                {
                  staticClass: "add-to-betslip-button",
                  on: {
                    click: function($event) {
                      return _vm.addToBetslip(
                        _vm.parlays.SelectionData,
                        "popularparlays",
                        "SGP",
                        _vm.parlays.IDFWMarketGroup
                      )
                    }
                  }
                },
                [
                  _c("button", [
                    _vm._v(_vm._s(_vm.$t("Popular.Parlays.AddToBetslip")))
                  ]),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("Popular.Parlays.Potential.Return", {
                          num: _vm.winning(
                            _vm.parlays.BetCalculation.ProviderCalculation,
                            "SGP"
                          ),
                          stake: _vm.parlayStake
                        })
                      )
                    }
                  })
                ]
              )
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.betType === "SGP+"
      ? _c("div", { staticClass: "parlays-container SGPPlus" }, [
          _c(
            "div",
            {
              staticClass: "parlay-header",
              on: {
                click: function($event) {
                  return _vm.viewMore(
                    _vm.parlays,
                    "SGP+",
                    "popularparlays",
                    _vm.parlays.IDFWMarketGroup
                  )
                }
              }
            },
            [
              _c("div", { staticClass: "title-wrapper" }, [
                _c("div", { staticClass: "sgpplus-title-wrapper" }, [
                  _vm.sortedEventData(_vm.parlays.SelectionData)
                    ? _c("span", { staticClass: "sgp-plus-icon" })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "header-title",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("Popular.Parlays.Number.Of.SGPPlus", {
                          num: _vm.parlays.SelectionData.length
                        })
                      )
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "title-wrapper-potential-return" }, [
                  _c(
                    "span",
                    { staticClass: "potential-return" },
                    [
                      _c("odds", {
                        attrs: {
                          potentialReturn: _vm.parlayPotentialReturn(
                            _vm.parlays.BetCalculation.CalculationXP
                          ),
                          na: "-"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("span", {
                  staticClass: "number-of-selections",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.numberOfSGP(_vm.parlays.SelectionData).moreThanOne > 1
                        ? _vm.$t(
                            "Popular.Parlays.Number.Of.SGP.In.SGPPlus.MoreThenOne",
                            {
                              num: _vm.numberOfSGP(_vm.parlays.SelectionData)
                                .moreThanOne
                            }
                          )
                        : _vm.$t("Popular.Parlays.Number.Of.SGP.In.SGPPlus", {
                            num: _vm.numberOfSGP(_vm.parlays.SelectionData)
                              .moreThanOne
                          })
                    )
                  }
                }),
                _vm._v(" "),
                _vm.numberOfSGP(_vm.parlays.SelectionData).onlyOne > 0
                  ? _c("span", {
                      staticClass: "number-of-selections",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.numberOfSGP(_vm.parlays.SelectionData).onlyOne > 1
                            ? _vm.$t(
                                "Popular.Parlays.Number.Of.Selections.In.SGPPlus.MoreThenOne",
                                {
                                  num: _vm.numberOfSGP(
                                    _vm.parlays.SelectionData
                                  ).onlyOne
                                }
                              )
                            : _vm.$t(
                                "Popular.Parlays.Number.Of.Selections.In.SGPPlus",
                                {
                                  num: _vm.numberOfSGP(
                                    _vm.parlays.SelectionData
                                  ).onlyOne
                                }
                              )
                        )
                      }
                    })
                  : _vm._e()
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "content-wrapper",
              on: {
                click: function($event) {
                  return _vm.viewMore(
                    _vm.parlays,
                    "SGP+",
                    "popularparlays",
                    _vm.parlays.IDFWMarketGroup
                  )
                }
              }
            },
            _vm._l(_vm.sortedEventData(_vm.parlays.SelectionData), function(
              parlay,
              index
            ) {
              return _c(
                "div",
                {
                  key: index + "-event-" + parlay[0].market.idfoevent,
                  staticClass: "parlay-selection SGPPlus"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "content-left",
                      class: { "has-more-than-2-legs": parlay.length > 2 }
                    },
                    [
                      _c("div", { staticClass: "SGP" }, [
                        _c("div", { staticClass: "leg-icon" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "sgp-title" }, [
                          parlay.length > 1
                            ? _c("span", { staticClass: "sgp-icon" })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "title-with-return",
                              class: { isSGP: parlay.length > 1 }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "event-name",
                                  on: {
                                    click: function($event) {
                                      return _vm.goToEvent(
                                        parlay[0].market,
                                        "popularparlays",
                                        _vm.parlays.SelectionData,
                                        "SGP+",
                                        _vm.parlays.IDFWMarketGroup,
                                        undefined
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.isAmericanSport(parlay[0].market)
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "potential-return" },
                                [
                                  _c("odds", {
                                    attrs: {
                                      potentialReturn: _vm.getPriceByIdfoSelection(
                                        _vm.parlays,
                                        parlay[0].selections[0].idfoselection
                                      ),
                                      na: ""
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._l(parlay, function(par) {
                        return _c(
                          "div",
                          {
                            key:
                              "sgp-selection-" +
                              par.selections[0].idfoselection,
                            staticClass: "sgp-selection"
                          },
                          [
                            _c("div", { staticClass: "leg-icon" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "selection-data-wrapper" },
                              [
                                _c("div", { staticClass: "selection-data" }, [
                                  _c(
                                    "span",
                                    { staticClass: "selection-name" },
                                    [
                                      _vm._v(
                                        _vm._s(par.selections[0].name) + " "
                                      ),
                                      _c("handicap", {
                                        attrs: { selection: par.selections[0] }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "market-name" }, [
                                    _vm._v(_vm._s(par.market.name))
                                  ])
                                ]),
                                _vm._v(" "),
                                parlay.length < 2
                                  ? _c(
                                      "span",
                                      { staticClass: "potential-return" },
                                      [
                                        _c("odds", {
                                          attrs: {
                                            potentialReturn:
                                              par.selections[0].price,
                                            na: "-"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.showViewMore && _vm.parlays.SelectionData.length > 3
            ? _c("div", { staticClass: "view-more-container" }, [
                _c("div", { staticClass: "leg-icon" }),
                _vm._v(" "),
                _c("div", { staticClass: "view-more" }, [
                  _c("button", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.parlays.SelectionData.length - 3 > 1
                          ? _vm.$t("Popular.Parlays.ViewMoreThenOne", {
                              num: _vm.parlays.SelectionData.length - 3
                            })
                          : _vm.$t("Popular.Parlays.ViewMore", {
                              num: _vm.parlays.SelectionData.length - 3
                            })
                      )
                    },
                    on: {
                      click: function($event) {
                        return _vm.viewMore(
                          _vm.parlays,
                          "SGP+",
                          "popularparlays",
                          _vm.parlays.IDFWMarketGroup
                        )
                      }
                    }
                  })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "add-to-betslip-wrapper" }, [
            _c(
              "div",
              {
                staticClass: "add-to-betslip-button",
                on: {
                  click: function($event) {
                    return _vm.addToBetslip(
                      _vm.parlays.SelectionData,
                      "popularparlays",
                      "SGP+",
                      _vm.parlays.IDFWMarketGroup
                    )
                  }
                }
              },
              [
                _c("button", [
                  _vm._v(_vm._s(_vm.$t("Popular.Parlays.AddToBetslip")))
                ]),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("Popular.Parlays.Potential.Return", {
                        num:
                          _vm.winning(
                            _vm.parlays.BetCalculation.CalculationXP
                          ) || "-",
                        stake: _vm.parlayStake
                      })
                    )
                  }
                })
              ]
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1bd40456", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bd40456","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/popularParlays/PopularParlay.vue
// module id = null
// module chunks = 